import { useEffect, useState, type ReactNode } from 'react';
import {
  clearSubmitFeedback,
  getSubmitFeedback,
  subscribeSubmitFeedback,
  type SubmitFeedback,
} from '../../lib/silentSubmit';

/**
 * Global processing / success / error overlay for contact, connect, and report forms.
 */
export function SubmitFeedbackProvider({ children }: { children: ReactNode }) {
  const [feedback, setFeedback] = useState<SubmitFeedback>(getSubmitFeedback());

  useEffect(() => subscribeSubmitFeedback(setFeedback), []);

  return (
    <>
      {children}
      {feedback ? (
        <div
          className={`ileafs-submit-success ileafs-submit-success--${feedback.phase}`}
          role="status"
          aria-live="polite"
        >
          <div className="ileafs-submit-success__card">
            {feedback.phase === 'processing' ? (
              <span className="ileafs-submit-success__spinner" aria-hidden />
            ) : feedback.phase === 'success' ? (
              <span className="ileafs-submit-success__tick" aria-hidden>
                <svg viewBox="0 0 64 64" fill="none">
                  <circle cx="32" cy="32" r="30" stroke="currentColor" strokeWidth="4" />
                  <path
                    d="M18 33.5l9 9L46 22"
                    stroke="currentColor"
                    strokeWidth="5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            ) : (
              <span className="ileafs-submit-success__error" aria-hidden>
                !
              </span>
            )}
            <h2>{feedback.title}</h2>
            <p>{feedback.message}</p>
            {feedback.phase !== 'processing' ? (
              <button type="button" className="vs-btn style1" onClick={() => clearSubmitFeedback()}>
                Close
              </button>
            ) : (
              <p className="ileafs-submit-success__hint">Working in the background…</p>
            )}
          </div>
        </div>
      ) : null}
    </>
  );
}
